import ModalView from "../view/modal.js";
import ButtonView from "../view/button.js";

import ModalModel from "../model/modal.js";

import Animation from "../../animation/animation.js";

import {
  render,
  RenderPosition,
  removeElement
} from "../../render/render.js";

import {
  defaultModalModelData,
  ModalActionType as ActionType
} from "../const.js";

export default class Modal {
  constructor(triggerElement, wrapperElement) {
    this._triggerElement = triggerElement;
    this._wrapperElement = wrapperElement;
    this._wrapperParentElement = this._wrapperElement.parentElement;

    this._animation = new Animation();

    this._modalView = null;
    this._buttonView = null;

    this._model = null;

    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleTriggerClick = this._handleTriggerClick.bind(this);
    this._handleModalClick = this._handleModalClick.bind(this);
    this._handleModalCloseButtonClick = this._handleModalCloseButtonClick.bind(this);
  }

  init() {
    this._model = new ModalModel(Object.assign(
        {},
        defaultModalModelData
    ));
    this._model.addObserver(this._handleChangeData);

    this._buttonView = new ButtonView(this._triggerElement);
    this._modalView = new ModalView();

    this._buttonView.setClickHandler(this._handleTriggerClick);
  }

  _processRender() {
    this._modalView = new ModalView();
    const modalSection = this._modalView.getElement();

    render(
        this._modalView.getSubcategoriesContainer(),
        this._wrapperElement
    );

    render(
        document.body,
        modalSection
    );

    this._animation.fadeIn(
        this._modalView.getElement()
    );

    this._modalView.setSectionClickHandler(this._handleModalClick);
    this._modalView.setCloseButtonClickHandler(this._handleModalCloseButtonClick);
  }

  _processDestroy() {
    const modalSection = this._modalView.getElement();
    this._modalView = null;

    this._animation.fadeOut(
        modalSection,
        null,
        () => {
          render(
              this._wrapperParentElement,
              this._wrapperElement,
              RenderPosition.AFTERBEGIN
          );

          removeElement(modalSection);
        }
    );
  }

  _handleTriggerClick() {
    if (this._model.getData.rendered) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          rendered: true
        }
    ), ActionType.RENDER);
  }

  _handleModalClick(evt) {
    if (!this._modalView) {
      return;
    }

    if (this._modalView.getModalContainer().contains(evt.target)) {
      return;
    }

    if (!this._model.getData().rendered) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          rendered: false
        }
    ), ActionType.DESTROY);
  }

  _handleModalCloseButtonClick() {
    if (!this._modalView) {
      return;
    }

    if (!this._model.getData().rendered) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          rendered: false
        }
    ), ActionType.DESTROY);
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.RENDER:
        this._processRender();
        break;
      case ActionType.DESTROY:
        this._processDestroy();
        break;
    }
  }
}
